import script from "./AudienceManagementModalDelete.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudienceManagementModalDelete.vue?vue&type=script&lang=ts&setup=true"

import "./AudienceManagementModalDelete.vue?vue&type=style&index=0&id=68692d7d&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68692d7d"]])

export default __exports__